module.exports = __webpack_public_path__ + "img/circle_check.7cd13598.svg";